import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import { Link, useSearchParams } from "react-router-dom";
import { Col } from "react-bootstrap";
import {
  getwatersportsList,
  deleteWatersports,
} from "../store/slices/waterSports";
import DeleteModal from "../utils/Modals/DeleteModel";
import ShowSkeleton from "../utils/helpers/skeleton";
import ReactPaginate from "react-paginate";

const WaterSport = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isloading, setisLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const itemsPerPage = 10;
  const dispatch = useDispatch();
  const [search, setSearch] = useSearchParams();
  const querypage = parseInt(search.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(querypage);
  const [totalData, setTotalData] = useState(0);
  const [name, setName] = useState(""); // ✅ Added state for name filter

  useEffect(() => {
    setisLoading(true);
    getwatersports(); // ✅ Correct: calls API with page, name, limit properly
  }, [currentPage, name]);

  const item = {
    limit: itemsPerPage,
    page: currentPage,
    name: name.trim() !== "" ? name : undefined, // ✅ Filter by name
  };

  const handlePageChange = (event) => {
    const newPage = event.selected + 1;
    setCurrentPage(newPage);
    search.set("page", newPage);
    setSearch(search, { replace: true });
  };

  const getwatersports = () => {
    dispatch(getwatersportsList(item))
      .unwrap()
      .then((data) => {
        setData(data?.WaterSportsData);
        setTotalData(data?.totalDataCount);
        console.log(data?.totalDataCount);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setisLoading(false);
      });
  };

  const totalPages = Math.ceil(totalData / itemsPerPage);

  const openDeleteModal = (_id) => {
    setDeleteId(_id);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    let item = {
      id: id,
    };
    if (item) {
      dispatch(deleteWatersports(item))
        .unwrap()
        .then((data) => {
          console.log("Deleted item data:", data);
          getwatersports();
          setShowModal(false);
        })
        .catch((error) => {
          console.error("Delete error: ", error);
        });
    } else {
      console.error("No deleteId set.");
    }
  };

  return (
    <>
      <DeleteModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleDelete={() => handleDelete(deleteId)}
      />
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Water Sports</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Water Sports</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header  bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
          <Link
            to="/admin/add-watersport"
            className="btn btn-primary text-md btn-sm px-8 py-8 text-sm radius-8 d-flex align-items-center gap-2"
          >
            Add New
          </Link>
        </div>
        <div className="card-body px-24 py-2">
          <div className="table-responsive scroll-sm">
            {isloading ? (
              <Col lg={12} xs={12} md={12} align="center">
                {ShowSkeleton()}
              </Col>
            ) : (
              <table className="table striped-table mb-0">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="d-flex align-items-center gap-10">
                        S.L
                      </div>
                    </th>

                    <th scope="col">Sport Name</th>
                    <th scope="col">Image</th>
                    <th scope="col">Places</th>

                    <th scope="col" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center gap-10">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </div>
                      </td>

                      <td style={{ width: "350px" }}>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {item.name}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <img
                              src={item?.image[0]?.mediaLink}
                              alt=""
                              style={{ height: "80px", borderRadius: "10px" }}
                            />
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "350px" }}>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {Array.isArray(item.place)
                                ? item.place.map((p) => p.placeName).join(", ")
                                : item.place?.placeName || "-"}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <Link
                            to={`/admin/edit-watersport/${item._id}`}
                            className="text-md bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-28-px h-28-px d-flex justify-content-center align-items-center rounded-circle"
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                          </Link>
                          {/* <button
                            type="button"
                            onClick={() => openDeleteModal(item._id)}
                            className="text-md remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-28-px h-28-px d-flex justify-content-center align-items-center rounded-circle"
                          >
                            <Icon
                              icon="fluent:delete-24-regular"
                              className="menu-icon"
                            />
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="d-flex justify-content-between mt-3">
            <span>&nbsp;</span>
            <ReactPaginate
              previousLabel={"«"}
              nextLabel={"»"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeLinkClassName={"active"}
              previousClassName={"previous"}
              nextClassName={"next"}
              disabledClassName={"disabled"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              breakLinkClassName={"page-link"}
              forcePage={currentPage - 1}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WaterSport;
